import React from "react";
import EmptyContainer from "components/common/empty_container/EmptyContainer";
import "components/common/empty_data/EmptyTableData.css";

const EmptyTableData = ({
  title = "No records found",
  content = "There are no records with the above criteria.",
  titleStyle,
  contentStyle,
}) => {
  return (
    <EmptyContainer
      height="169px"
      noDataText={
        <div style={{ textAlign: "center" }}>
          <h3 className="empty__title" style={titleStyle}>
            {title}
          </h3>
          <div className="empty__content" style={contentStyle}>
            {content}
          </div>
        </div>
      }
    />
  );
};

export default EmptyTableData;
